import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActionInfo } from '../action/ActionInfo';
import { FormGroup } from '@angular/forms';
import { ActionInfoType } from './ActionInfo';
import { ApplicationService } from '../application-service/application.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wbm-config-action-info',
    templateUrl: './config-action-info.component.html',
    styleUrls: ['../../assets/theme/css/attribute.css']
})
export class ConfigActionInfoComponent implements OnInit, OnDestroy {

    @Input() actionInfo: ActionInfo;
    @Input() formGroup: FormGroup;

    actionInfoType = ActionInfoType;

    private configDetailWidth: number;
    private subscriptions: Array<Subscription> = [];

    constructor(private _application: ApplicationService) { }

    ngOnInit() {
        this.subscriptions.push(this._application.configWidthValueChanges().subscribe(result => this.configDetailWidth = result));
    }

    ngOnDestroy() {
        //release global subscriptions
        this.removeGlobalSubscriptions();
    }

    private removeGlobalSubscriptions() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }
}
